// eslint-disable-next-line import/no-extraneous-dependencies
import { events } from 'aws-amplify/data';
import onlineService from '../onlineService';

export default {
  async connectToChannel(channelName) {
    try {
      const canConnect = await onlineService.canConnectRealtime();
      if (!canConnect) {
        return null;
      }

      const channel = await events.connect(channelName);

      return channel;
    } catch (error) {
      console.error('Error connecting to channel:', error);
      return null;
    }
  },

  async postEvent(channelName, eventData) {
    try {
      await events.post(channelName, eventData);
    } catch (error) {
      console.error('Error posting event:', error);
    }
  },
};
